let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("1ev3J")]).then(() => parcelRequire('lgmh3'));